import { userPoolClientId, userPoolId, region } from "./globalVariables";

export const AWS_CONFIG = {
    region: region,
    userPoolId: userPoolId,
    userPoolClientId: userPoolClientId,
    authenticationFlowType: 'USER_SRP_AUTH',
}

